/** Translation keys of a step, in the app's translations. */
export const onboardingTourStepKeys = (id) => ({
    title: `OnboardingTour:${id}:Title`,
    body: `OnboardingTour:${id}:Body`,
    tip: `OnboardingTour:${id}:Tip`,
});
